module.exports = __webpack_public_path__ + "static/sidemail-logo-blackwhite-4e887915ae68833de7d60b062c1cc482.png";